import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedLoginLogComponent } from './shared-login-log.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [SharedLoginLogComponent],
  exports: [SharedLoginLogComponent]
})
export class SharedLoginLogModule { }
